<table class="table table-condensed" id="tblSubscriptionCart" role="presentation">
    <thead>
        <tr>
            <td></td>
            <th>Jurisdiction</th>
            <th style="text-align:right">Monthly</th>
        </tr>
    </thead>

    <tbody>
        {{#each subscriptions}}
        <tr data-appid="{{appId}}">
            <td><a href="#" role="button" title='Remove from cart' class='glyphicon glyphicon-trash'></a></td>
            <td>{{appDisplayName}}</td>
            <td>{{dollars cost}}</td>
        </tr>
        {{/each}}
    </tbody>

    <tfoot>
        {{#if packageDiscountAmount}}
        <tr class="total1-row">
            <td></td>
            <th>Sub Total</th>
            <th>{{dollars subtotal}}</th>
        </tr>
        <tr class="discount-row">
            <td></td>
            <th>Discount (<span class="discount-amount">{{percent packageDiscountPct}}</span>)</th>
            <th>-{{dollars packageDiscountAmount}}</th>
        </tr>
        {{/if}}
        <tr class="total2-row">
            <td></td>
            <th>Due Monthly</th>
            <th>{{dollars dueMonthly}}</th>
        </tr>
        {{#if promoDiscountAmount}}
        <tr class="promocode-row">
            <td></td>
            <th>Promo Code ({{promoDiscountName}})</th>
            <th>-{{dollars promoDiscountAmount}}</th>
        </tr>
        <tr class="total3-row">
            <td></td>
            <th>Due Today</th>
            <th>{{dollars dueToday}}</th>
        </tr>
        {{/if}}
    </tfoot>
</table>

<div class="error">
    {{#each problems}}
    <div class="error-message" style="color:#cb0000">{{this}}</div>
    {{/each}}
</div>

{{#if problems}}
<div class="clearfix">
    <div class="pull-right">
        <button class="btn btn-primary btn-sm" disabled>Checkout</button>
    </div>
</div>
{{else}}
<form action="CreatePackageOrder" method="get">
    <div class="clearfix">
        <div class="pull-right">
            <button class="btn btn-primary btn-sm btnBuyNow">Checkout</button>
        </div>
    </div>
    <input type="hidden" name="returnUrl" value="{{ReturnUrl}}" />
    <input type="hidden" name="promoCode" value="{{promoDiscountCode}}" />
    <input type="hidden" name="plan" value="{{tier}}" />
    {{#each subscriptions}}
    <input type="hidden" name="appIds" value="{{appId}}" />
    {{/each}}
</form>
{{/if}}
